module.exports = __webpack_public_path__ + "img/bank9.3277c52f.png";